/* eslint-disable @typescript-eslint/no-explicit-any */
import colorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";
import {
  CheckoutRootVo,
  IPaymentListReq,
  IrepayOrderReq,
  LocalInfoVo,
  OrderPriceDetailVo,
  IPaymentVo,
  UserAddressVo,
  IWechatPayReq,
  IWechatPayRes,
  IValidateAppleMerchantReq,
  ICheckContactParams,
  ICheckContactResp,
} from "./checkout.interface";
import { getFormatCheckoutInfo } from "./checkoutRootToCommon";
import { getFormatSubmitInfo } from "./convert/SubmitDto2Vo";
import { getFormatPaymentList } from "./convert/PaymentDto2Vo";
import { uniformBizInfo } from "./constants/constants";

// Search checkout order
export const getCurrentOrder = (
  requestData: any,
): Promise<{ data: CheckoutRootVo; code: string; msg: string; localInfo: LocalInfoVo }> => {
  // 原se_currentOrder
  return colorAxiosInstance
    .post<any>("trade_checkout_get", undefined, { params: { ...requestData, uniformBizInfo } })
    .then((response: any) => {
      const { floors, structure } = response?.data?.data || {};

      return {
        data: getFormatCheckoutInfo(floors, structure),
        localInfo: response?.data?.data?.localInfo || {},
        code: response?.data?.resultCode || "",
        msg: response?.data?.msg || "",
      };
    });
};
// Search paypal config
// export const getPaypalConfig = (requestData: any): Promise<any> => {
//   return colorAxiosInstance
//     .post<any>("se_paypalConfig", undefined, { params: requestData })
//     .then((response: any) => {
//       return response.data.data;
//     });
// };

export const saveAddress = (requestData: any): Promise<any> => {
  // 原se_saveConsigneeAddress
  return colorAxiosInstance
    .post<any>("trade_checkout_changeAddress", undefined, {
      params: { ...requestData, uniformBizInfo },
    })
    .then((response: any) => {
      const { floors, structure } = response?.data?.data || {};
      return {
        data: getFormatCheckoutInfo(floors, structure),
        localInfo: response?.data?.data?.localInfo || {},
        code: response?.data?.resultCode || "",
        msg: response?.data?.msg || "",
      };
    });
};

// Submit order
export const submitOrder = (requestData: any): Promise<any> => {
  // 原se_submitOrder
  return colorAxiosInstance
    .post<any>("trade_checkout_submit", undefined, { params: { ...requestData, uniformBizInfo } })
    .then((response: any) => {
      return {
        code: response?.data?.resultCode || "",
        msg: response?.data?.msg || "",
        data: getFormatSubmitInfo(response?.data?.data?.floors || []),
      };
    });
};

// 订单capture
export const orderCapture = (requestData: any): Promise<any> => {
  // 原se_payment_capture
  return colorAxiosInstance
    .post<any>("trade_payment_capture", undefined, { params: requestData })
    .then((response: any) => {
      return response.data;
    });
};

// Search pay result
export const getPayResult = (requestData: any): Promise<any> => {
  // 原se_payment_getPayResult
  return colorAxiosInstance
    .post<any>("trade_payment_getPayResult", undefined, { params: requestData })
    .then((response: any) => {
      return response?.data?.data;
    });
};

// Search wechat pay result
export const getWechatPayResult = (requestData: IWechatPayReq): Promise<IWechatPayRes> => {
  // 原se_payment_getPayResult
  return colorAxiosInstance
    .post<IWechatPayReq>("trade_payment_getOuterStatus", undefined, { params: requestData })
    .then((response: { data: { data: IWechatPayRes } }) => {
      return response?.data?.data;
    });
};

// Redirect pay result
export const redirectPayResult = (requestData: any): Promise<any> => {
  // 原se_payment_redirect_result
  return colorAxiosInstance
    .post<any>("trade_payment_getRedirectPayResult", undefined, { params: requestData })
    .then((response: any) => {
      return response?.data?.data;
    });
};

// Search pay result
export const getPayNowInfo = (
  requestData: IPaymentListReq,
): Promise<{ list: IPaymentVo[]; orderInfo: any }> => {
  // 原se_payment_paymethods
  return colorAxiosInstance
    .post<any>("trade_payment_getPayNowInfo", undefined, { params: requestData })
    .then((response: any) => {
      return {
        list: getFormatPaymentList(response?.data?.data.payMethodList),
        orderInfo: response?.data?.data?.orderPriceInfo || {},
      };
    });
};

// repay order
export const repayOrder = (requestData: IrepayOrderReq): Promise<any> => {
  // 原getPayUrl
  return colorAxiosInstance
    .post<any>("trade_order_getPayUrl", undefined, { params: requestData })
    .then((response: any) => {
      let formateRes = "";
      console.log(response?.data, "rer");

      try {
        formateRes = response?.data?.data?.payInfo ? JSON.parse(response?.data?.data?.payInfo) : {};
      } catch (error) {
        console.log("Repay order error", error);
      }
      return {
        data: formateRes,
        msg: response?.data?.msg || "",
        code: response?.data?.code,
      };
    });
};

// 查询订单信息接口
export const getCheckoutInfo = (requestData: {
  billId: string;
}): Promise<{ billingAddress: UserAddressVo; orderPriceDetail: OrderPriceDetailVo }> => {
  // 原se_payment_billing_address
  return colorAxiosInstance
    .post<UserAddressVo>(`trade_payment_getCheckoutInfo`, undefined, {
      params: { ...requestData },
    })
    .then((response: any) => response.data.data);
};

// Save pay billing address
export const updatePaymentBillingAddress = (requestData: UserAddressVo): Promise<any> => {
  // 原se_payment_billing_address_update
  return colorAxiosInstance
    .post<any>("trade_payment_modifyBillingAddress", undefined, { params: requestData })
    .then((response: any) => {
      return {
        msg: response?.data?.msg || "",
        data: response?.data?.data,
        success: response?.data?.success,
      };
    });
};

/** 
 * 验证apple pay - merchant session
 * 
 * */ 
export const validateAppleMerchant = (
  requestData: IValidateAppleMerchantReq,
): Promise<any> => {
  return colorAxiosInstance
    .post<any>("trade_payment_validate", undefined, { params: requestData })
    .then((response: any) => {
      return response?.data?.data?.ext || ""
    });
};

/**
 * 检查邮箱绑定状态
 * @param params - 请求参数
 * @returns Promise<ICheckContactResp>
 */
export const checkContact = (
  requestData: ICheckContactParams,
): Promise<ICheckContactResp> => {
  return colorAxiosInstance
    .post<any>("user_account_checkContact", undefined, { params: requestData })
    .then((response: any) => {
      return response?.data || null
    });
};